import React from 'react';
import '../styles/header.css';
import { Link } from 'react-router-dom';
import logo from '../assets/images/logo_white.png' 

const Header = () => (
  <header>
    <nav class="header">
      <img alt="logo" src={logo} />
      <ul>
        <li><Link to='/'>Home</Link></li>
        <li><Link to='/mindfulbreathing'>Mindful Breathing</Link></li>
        <li><Link to='/about'>About us</Link></li>
      </ul>
    </nav>
  </header>
)

export default Header
